import { render, staticRenderFns } from "./inbound-outbound-detail.vue?vue&type=template&id=d9cbfe9a&scoped=true&"
import script from "./inbound-outbound-detail.vue?vue&type=script&lang=js&"
export * from "./inbound-outbound-detail.vue?vue&type=script&lang=js&"
import style0 from "./inbound-outbound-detail.vue?vue&type=style&index=0&id=d9cbfe9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cbfe9a",
  null
  
)

export default component.exports